__turbopack_context__.v({
  "available": "FinanceQuoteOption-module-scss-module__3prNFW__available",
  "breakdown": "FinanceQuoteOption-module-scss-module__3prNFW__breakdown",
  "desktop": "FinanceQuoteOption-module-scss-module__3prNFW__desktop",
  "fees": "FinanceQuoteOption-module-scss-module__3prNFW__fees",
  "feesSkeleton": "FinanceQuoteOption-module-scss-module__3prNFW__feesSkeleton",
  "hide": "FinanceQuoteOption-module-scss-module__3prNFW__hide",
  "interestRate": "FinanceQuoteOption-module-scss-module__3prNFW__interestRate",
  "loading": "FinanceQuoteOption-module-scss-module__3prNFW__loading",
  "logo": "FinanceQuoteOption-module-scss-module__3prNFW__logo",
  "mobile": "FinanceQuoteOption-module-scss-module__3prNFW__mobile",
  "quote": "FinanceQuoteOption-module-scss-module__3prNFW__quote",
  "quoteAmount": "FinanceQuoteOption-module-scss-module__3prNFW__quoteAmount",
  "quoteAmountSkeleton": "FinanceQuoteOption-module-scss-module__3prNFW__quoteAmountSkeleton",
  "quoteRate": "FinanceQuoteOption-module-scss-module__3prNFW__quoteRate",
  "quoteRateSkeleton": "FinanceQuoteOption-module-scss-module__3prNFW__quoteRateSkeleton",
  "repayment": "FinanceQuoteOption-module-scss-module__3prNFW__repayment",
  "root": "FinanceQuoteOption-module-scss-module__3prNFW__root",
  "unavailable": "FinanceQuoteOption-module-scss-module__3prNFW__unavailable",
  "vwfsAdvantage": "FinanceQuoteOption-module-scss-module__3prNFW__vwfsAdvantage",
});
